import { ref, onMounted, onUnmounted } from 'vue'

let deferredPrompt = null
const canInstall = ref(false)
const isStandalone = ref(false)

function onBeforeInstallPrompt(e) {
  e.preventDefault()
  deferredPrompt = e
  canInstall.value = true
}

function onAppInstalled() {
  deferredPrompt = null
  canInstall.value = false
}

export function usePwaInstall() {
  onMounted(() => {
    isStandalone.value = window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true

    window.addEventListener('beforeinstallprompt', onBeforeInstallPrompt)
    window.addEventListener('appinstalled', onAppInstalled)
  })

  onUnmounted(() => {
    window.removeEventListener('beforeinstallprompt', onBeforeInstallPrompt)
    window.removeEventListener('appinstalled', onAppInstalled)
  })

  async function promptInstall() {
    if (!deferredPrompt) return
    deferredPrompt.prompt()
    const { outcome } = await deferredPrompt.userChoice
    if (outcome === 'accepted') {
      canInstall.value = false
    }
    deferredPrompt = null
  }

  return {
    canInstall,
    isStandalone,
    promptInstall
  }
}
